// MEN-5390: the "12 sessions / 6 Months" copy on the booking rails. Shared so
// the member and admin flows cannot drift apart. Days * count / 30.4 is the
// standard average-month conversion; rounded to nearest integer matches the
// design copy.
export const seriesLengthLabel = (sessionCount: number, cadenceWeeks = 2) =>
  `${sessionCount} sessions / ${Math.max(
    1,
    Math.round((sessionCount * cadenceWeeks * 7) / 30.4),
  )} Months`;
